import styled from 'styled-components';
import { Text } from '../../CommonComponents/OPL/Text/Text';

export const SectionHeading = styled(Text)(({ theme }) => ({
  fontSize: theme.fontSizes.h6,
  fontWeight: theme.fontWeights['500'],
  color: theme.colors.neutral['600'],
  marginBottom: '32px',
}));
